<template>
  <div class="article-list-container">
    <!-- 文章列表 -->
    <div class="post-list">
      <article v-for="article in articles" :key="article.ID" class="post-card">
        <div class="post-category" @click="handleCategoryClick(article.Category)">
          {{ article.Category ? article.Category.name : '未分类' }}
        </div>
        <h3 class="post-title">
          <router-link :to="`/article/detail/${article.ID}`">{{ article.title }}</router-link>
        </h3>
        <p class="post-excerpt">{{ article.desc }}</p>
        <div class="post-meta">
          <div class="meta-dates">
            <time class="meta-date created-date">
              <i class="el-icon-time"></i>
              创建于 {{ formatDate(article.CreatedAt) }}
            </time>
            <time class="meta-date updated-date" v-if="article.UpdatedAt && article.UpdatedAt !== article.CreatedAt">
              <i class="el-icon-refresh"></i>
              更新于 {{ formatDate(article.UpdatedAt) }}
            </time>
          </div>
        </div>
      </article>
    </div>

    <!-- 分页 -->
    <el-pagination
      v-if="showPagination"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :pager-count="5"
      :current-page.sync="currentPage"
      @current-change="onPageChange"
      class="pagination">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'ArticleList',
  props: {
    // 文章列表数据
    articles: {
      type: Array,
      required: true,
      default: () => []
    },
    // 是否显示分页
    showPagination: {
      type: Boolean,
      default: true
    },
    // 总条数
    total: {
      type: Number,
      default: 0
    },
    // 每页条数
    pageSize: {
      type: Number,
      default: 10
    },
    // 当前页码
    currentPage: {
      type: Number,
      default: 1
    }
  },
  methods: {
    // 日期格式化
    formatDate(date) {
      if (!date) {
        return '未知时间'
      }

      try {
        const dateObj = new Date(date)
        if (isNaN(dateObj.getTime())) {
          return '未知时间'
        }

        return dateObj.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })
      } catch (error) {
        console.error('日期格式化错误:', error, date)
        return '未知时间'
      }
    },
    // 点击分类
    handleCategoryClick(category) {
      if (category) {
        this.$emit('category-click', category)
      }
    },
    // 页码变化
    onPageChange(page) {
      this.$emit('page-change', page)
    }
  }
}
</script>

<style scoped>
.article-list-container {
  position: relative;
}

.post-list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.post-card {
  background: var(--card-bg);
  border: none;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.post-card:hover {
  transform: translateY(-4px);
}

.post-category {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: #e8e1d5;
  color: #6b5f4c;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  transition: all 0.2s ease;
  cursor: pointer;
}

.post-category:hover {
  background-color: #e0d9cd;
  transform: translateY(-1px);
}

.post-title {
  font-size: 1.5rem;
  margin: 1rem 0;
}

.post-title a {
  color: #2d3748;
  text-decoration: none;
  position: relative;
  transition: all 0.3s ease;
  font-weight: 600;
}

.post-title a::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: -2px;
  left: 0;
  background-color: #6b5f4c;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.post-title a:hover {
  color: #4a5568;
}

.post-title a:hover::after {
  transform: scaleX(1);
}

.post-excerpt {
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 1rem 0;
}

.post-meta {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}

.meta-dates {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.meta-date {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  opacity: 0.8;
  font-size: 0.85rem;
}

.meta-date i {
  font-size: 0.8rem;
  opacity: 0.7;
}

.created-date {
  color: var(--text-secondary);
}

.updated-date {
  color: var(--text-secondary);
  opacity: 0.7;
  font-size: 0.8rem;
}

.pagination {
  margin-top: 2rem;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .post-card {
    padding: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .post-title {
    font-size: 1.25rem;
  }

  .post-excerpt {
    font-size: 0.95rem;
  }

  .meta-dates {
    gap: 0.5rem;
    flex-direction: column;
    align-items: flex-start;
  }

  .meta-date {
    font-size: 0.8rem;
  }

  .updated-date {
    font-size: 0.75rem;
  }
}
</style>
